import styled, { css } from 'styled-components';

import { Icon } from '@powdr/components';
import { ThemeProps as Prop, Breakpoints, FontFamily } from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

export const StyledOrderedShowcase = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ShowcaseItems = styled.ol`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 25px;
`;

export const ItemWrapper = styled.li`
  width: 100%;
  height: 100%;
  list-style: none;
`;

export const IndicatorBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;

  ${Breakpoints.desktopOnly(css`
    margin: ${({ $is5050 }) => (($is5050) ? '20px 0 20px' : '40px 0 30px')};
  `)}

  ${Breakpoints.mobile(css`
    margin: 20px 0 20px;
  `)}
`;

export const BarElement = styled.div`
  background-color: lightgrey;
  height: 10px;
  width: 100%;
  border-radius: 5px;
`;

export const IndicatorIconWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: translateX(-55%);

  ${Breakpoints.desktopOnly(css`
    top: ${({ $is5050 }) => (($is5050) ? 9 : 5)}px;
  `)}

  ${Breakpoints.mobile(css`
    top: 9px;
  `)}
`;

export const IndicatorIcon = styled(Icon)`
  display: flex;
  flex-direction: column;
  filter: drop-shadow(1px 2px 2px rgba(0, 0, 0, 0.4));

  ${Breakpoints.desktopOnly(css`
    height: ${({ $is5050 }) => (($is5050) ? 25 : 35)}px;
  `)}

  ${Breakpoints.mobile(css`
    height: 25px;
  `)}
`;

export const IndicatorText = styled.div`
  font-weight: bold;

  ${Breakpoints.desktopOnly(css`
    ${({ $is5050 }) => (($is5050)
    ? getFontStyles(FontFamily.BASE_FONT, undefined, 0.85)
    : getFontStyles(FontFamily.BASE_FONT, undefined, undefined))};
  `)}

  ${Breakpoints.mobile(css`
    ${() => getFontStyles(FontFamily.BASE_FONT, undefined, 0.85)};
  `)}
`;
